import { PersonalDetailsReqRes } from "src/app/account/models/personalDetailsReqRes.model";

export class OpportunityCampaignContactRequest {
    tags:string[];
    personalDetailsRequest:PersonalDetailsReqRes;
}